import Marquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "@/constants/content";

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="py-10 border-y border-white/5 overflow-hidden">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {MARQUEE_WORDS.concat(MARQUEE_WORDS).map((word, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif text-4xl sm:text-5xl font-light italic text-white/10 px-8">{word}</span>
          <span className="w-1.5 h-1.5 rounded-full bg-primary/30" />
        </span>
      ))}
    </Marquee>
  </div>
);
